/* eslint-disable */
// initial state
// shape: [{ id, quantity }]
const state = {
  myTradeTotal: '0',
  myOrderTotal: '0',
  myHisOrderTotal: '0',
  myTradeRecord: [],
  myTradeRecord1: [],

  myOrderRecord: [],
  myHisOrderRecord: [],
  selAssetDetail: {},
  myAsset: [],
  hazardRate: '0.00', // 风险率合约
  listTotalAssetsMsg: '0.00',// 当前权益
  // commodityStrategy:[],//商品信息
  /* 心跳 */
  h_tradeTime: null,// 成交更新时间
  h_holdTime: null,//持仓汇总更新时间
  h_orderTime: null,//委托更新时间
  h_avilibleMargin: null,//可用资金
  /* 心跳 end */
  systemTime: Number(new Date()),// 系统时间
  marketStatus:{status:''},// status 市场状态 O:开市准备中,T:交易中,P:休市中,R:准备结算中,E:结算中,C:闭市中
  isChangeMarginPsd: true,// 当前用户是否修改过资金密码
  userPositionSummaries: [], // 当前保存的交易页面持仓汇总信息
  
}

// getters
const getters = {
  listTotalAssetsMsgGetter: state => state.listTotalAssetsMsg,
  hazardRateGetter: state => state.hazardRate,
  selAssetDetailGetter: state => state.selAssetDetail,
  myTradeTotalGetter: state => state.myTradeTotal,
  myOrderTotalGetter: state => state.myOrderTotal,
  myHisOrderTotalGetter: state => state.myHisOrderTotal,
  myTradeRecordGetter: (state) => {
    return state.myTradeRecord
  },
  myTradeRecordGetter1: (state) => {
    return state.myTradeRecord1
  },
  myOrderRecordGetter: (state) => {
    return state.myOrderRecord
  },
  myHisOrderRecordGetter: (state) => {
    return state.myHisOrderRecord
  },
  myAssetGetter: state => state.myAsset,
  // commodityStrategyGetter: state => state.commodityStrategy ,
  h_tradeTime: state => state.h_tradeTime,
  h_holdTime: state => state.h_holdTime,
  h_orderTime: state => state.h_orderTime,
  marketStatusGetter: state => state.marketStatus,
  h_avilibleMargin: state => state.h_avilibleMargin,
  isChangeMarginPsdGetter: (state) => {
    return state.isChangeMarginPsd
  },
  userPositionSummariesGetter: state => state.userPositionSummaries,
  systemTimeGetter: state => state.systemTime,
}

// actions
const actions = {

}

// mutations
const mutations = {
  setListTotalAssetsMsg(state, data) {
    state.listTotalAssetsMsg = data
  },
  setHazardRate(state, data) {
    state.hazardRate = data
  },
  setMyTradeTotal(state, data) {
    state.myTradeTotal = data
  },
  setMyOrderTotal(state, data) {
    state.myOrderTotal = data
  },
  setMyHisOrderTotal(state, data) {
    state.myHisOrderTotal = data
  },
  setMyTradeRecord(state, data) {
    state.myTradeRecord = data
  },
  setMyTradeRecord1(state, data) {
    state.myTradeRecord1 = data
  },
  setMyOrderRecord(state, data) {
    state.myOrderRecord = data
  },
  setMyHisOrderRecord(state, data) {
    state.myHisOrderRecord = data
  },
  setMyAsset(state, data) {
    state.myAsset = data
  },
  // setCommodityStrategy(state, data) {
  //   state.commodityStrategy = data
  // },
  setH_tradeTime(state, data) {
    state.h_tradeTime = data
  },
  setH_holdTime(state, data){
    state.h_holdTime = data
  },
  setH_orderTime(state, data){
    state.h_orderTime = data
  },
  setMarketStatus(state, data){
    state.marketStatus = data
  },
  setH_avilibleMargin(state, data){
    state.h_avilibleMargin = data
  },
  setChangeMarginPsd(state, data) {
    state.isChangeMarginPsd = data
  },
  setNewUserPositionSummaries(state, data) {
    state.userPositionSummaries = data
  },
  setSystemTime(state, data) {
    state.systemTime = data
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
